import type { RegionMappings } from '@fsd/app/locale';
import { getLocaleOptions } from '@/utils/i18n/getLanguageOptions';
import { getTimeZone } from '@/utils/i18n/timezone';

/**
 * Las tablas `Locale` → BCP 47 y `Timezone` → IANA que usa `useFormatters`, para la región de `fsd/`
 * (que no puede importar `utils/i18n`). Las inyecta `FsdContext`; vive aparte para que el test de
 * paridad use exactamente las mismas.
 */
export const fsdRegionMappings: RegionMappings = {
  // El argumento de `getLocaleOptions` solo cambia las etiquetas, no el mapeo enum → BCP 47.
  localeToBcp47: (locale) =>
    getLocaleOptions('es').find((option) => option.enumValue === locale)?.value,
  timeZoneToIana: getTimeZone,
};
